import React from "react";
import { useNavigate } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import { motion } from "framer-motion";
import 'primeicons/primeicons.css';
import './Stickymenu.css';

export default function Stickymenu () {

    const navigate = useNavigate();

    return (
        <motion.div 
            className="menu-container"
            whileHover={{scale: 1.1}} >
            <div className="menu">
                <Link to="/#hero" className="menu-item">
                    <i onClick={() => navigate('/#hero')} className="pi pi-user"></i>
                </Link>
                <Link to="/#story" className="menu-item">
                    <i onClick={() => navigate('/#story')} className="pi pi-info-circle"></i>
                </Link>
                <Link to="/#projects" className="menu-item">
                    <i onClick={() => navigate('/#projects')} className="pi pi-folder-open"></i>
                </Link>
                <Link to="/#pitch" className="menu-item">
                    <i onClick={() => navigate('/#pitch')} className="pi pi-comment"></i>
                </Link>
            </div>
        </motion.div>
    )
}